var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- ko with: props --> <button class="nfd-btn-red nfd-btn-red-default"type="button"data-bind="click: onClick, css: btnClasses, enable: enable"> <span class="nfd-btn-red-content"><!-- ko if: content --> <span data-bind="html: content"></span><!-- /ko --> <!-- ko template: { nodes: $componentTemplateNodes, data: $parent } --><!-- /ko --> </span> </button> <!-- /ko -->';
}
return __p;
};
